import { FunctionComponent } from 'react';
import { Div, Headline, BodyText, Button } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

interface NoAccesToResourceProps {}

const NoAccesToResource: FunctionComponent<NoAccesToResourceProps> = () => {
  const { t } = useTranslation('authentication');

  const history = useHistory();

  const handleClick = (): void => {
    history.push('/home');
  };

  return (
    <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
      <Headline size="md" block>
        {t('AuthenticationComponent.errorModal.titleAccessFailedWhenAuthenticated')}
      </Headline>
      <BodyText margin={{ top: 'xlg', bottom: 'xxlg' }} padding={{ top: 'md' }} color="gray800">
        {t('AuthenticationComponent.errorModal.contentAccessFailedWhenAuthenticated')}
      </BodyText>
      <Button variant="secondary" size="lg" onClick={handleClick}>
        {t('AuthenticationComponent.errorModal.mainPageButton')}
      </Button>
    </Div>
  );
};

export default NoAccesToResource;
